// Generated by Avo VERSION 120.192.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Staging = "staging",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "6a441oyDbiUHVPO8EJh1";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "xbAiIILzXKdoJJX3T9yz",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "WT5UNEkzLbpQZNA6yhMA",
          "se": (new Date()).toISOString(),
          "so": "SodLVgi1h",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "xbAiIILzXKdoJJX3T9yz",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "WT5UNEkzLbpQZNA6yhMA",
          "se": (new Date()).toISOString(),
          "so": "SodLVgi1h",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "WT5UNEkzLbpQZNA6yhMA",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export const Source = {
  'PLAYER': 'Player',
  'WWW': 'WWW',
  'PLAYER_WWW': 'Player-WWW',
  'PLAYER_IOS': 'Player-iOS',
  'PLAYER_ANDROID': 'Player-Android',
  'STUDIO': 'Studio',
  'API': 'Api',
} as const;
export type SourceType = typeof Source;
export type SourceValueType = SourceType[keyof SourceType];

export const ContextLibraryName = {
  'ANALYTICS_IOS': 'analytics-ios',
  'ANALYTICS_ANDROID': 'analytics-android',
  'ANALYTICS_WEB_DESKTOP': 'analytics-web-desktop',
  'ANALYTICS_WEB_MOBILE_IOS': 'analytics-web-mobile-ios',
  'ANALYTICS_WEB_MOBILE_ANDROID': 'analytics-web-mobile-android',
  'ANALYTICS_API': 'analytics-api',
} as const;
export type ContextLibraryNameType = typeof ContextLibraryName;
export type ContextLibraryNameValueType = ContextLibraryNameType[keyof ContextLibraryNameType];

export const FieldName = {
  'EMAIL': 'Email',
  'PASSWORD': 'Password',
  'CARD': 'Card',
} as const;
export type FieldNameType = typeof FieldName;
export type FieldNameValueType = FieldNameType[keyof FieldNameType];

export const PlanType = {
  'MONTHLY_PLAN': 'monthly_plan',
  'YEARLY_PLAN': 'yearly_plan',
} as const;
export type PlanTypeType = typeof PlanType;
export type PlanTypeValueType = PlanTypeType[keyof PlanTypeType];

export const ContextDeviceType = {
  'IOS': 'ios',
  'ANDROID': 'android',
  'WEB': 'web',
  'API': 'api',
} as const;
export type ContextDeviceTypeType = typeof ContextDeviceType;
export type ContextDeviceTypeValueType = ContextDeviceTypeType[keyof ContextDeviceTypeType];

export const Provider = {
  'EMAIL': 'Email',
  'TWITTER': 'Twitter',
  'FACEBOOK': 'Facebook',
  'GOOGLE': 'Google',
  'TRY_APP': 'Try App',
  'DEVELOPER_BACKDOOR': 'Developer Backdoor',
  'BRANCH': 'Branch',
} as const;
export type ProviderType = typeof Provider;
export type ProviderValueType = ProviderType[keyof ProviderType];

let sysContextDeviceType: any;
let sysContextLibraryName: any;
let sysContextLibraryVersion: any;
let sysSource: any;
let sysAcquisitionChannel: any;
let sysMarketingTitle: any;
let sysContextUtmCampaign: any;
let sysContextUtmMedium: any;
let sysTags: any;
let sysCampaign: any;
let sysMediaSource: any;
let sysChannel: any;
let sysContextUtmSource: any;
let sysContextUtmContent: any;
let sysOffer: any;
let sysContextUtmTerm: any;
let sysConnectionType: any;
let sysIsOnline: any;

export function setSystemProperties(
  properties: {contextDeviceType: ContextDeviceTypeValueType;
  contextLibraryName: ContextLibraryNameValueType;
  contextLibraryVersion: string; source: SourceValueType;
  acquisitionChannel: string | null | undefined;
  marketingTitle: string | null | undefined;
  contextUtmCampaign: string | null | undefined;
  contextUtmMedium: string | null | undefined;
  tags: string | null | undefined; campaign: string | null | undefined;
  mediaSource: string | null | undefined; channel: string | null | undefined;
  contextUtmSource: string | null | undefined;
  contextUtmContent: string | null | undefined;
  offer: string | null | undefined;
  contextUtmTerm: string | null | undefined;
  connectionType: string | null | undefined;
  isOnline: boolean | null | undefined}) {
  if (properties.contextDeviceType !== null && properties.contextDeviceType !== undefined) {
    sysContextDeviceType = properties.contextDeviceType;
  }
  if (properties.contextLibraryName !== null && properties.contextLibraryName !== undefined) {
    sysContextLibraryName = properties.contextLibraryName;
  }
  if (properties.contextLibraryVersion !== null && properties.contextLibraryVersion !== undefined) {
    sysContextLibraryVersion = properties.contextLibraryVersion;
  }
  if (properties.source !== null && properties.source !== undefined) {
    sysSource = properties.source;
  }
  if (properties.acquisitionChannel !== null && properties.acquisitionChannel !== undefined) {
    sysAcquisitionChannel = properties.acquisitionChannel;
  }
  if (properties.marketingTitle !== null && properties.marketingTitle !== undefined) {
    sysMarketingTitle = properties.marketingTitle;
  }
  if (properties.contextUtmCampaign !== null && properties.contextUtmCampaign !== undefined) {
    sysContextUtmCampaign = properties.contextUtmCampaign;
  }
  if (properties.contextUtmMedium !== null && properties.contextUtmMedium !== undefined) {
    sysContextUtmMedium = properties.contextUtmMedium;
  }
  if (properties.tags !== null && properties.tags !== undefined) {
    sysTags = properties.tags;
  }
  if (properties.campaign !== null && properties.campaign !== undefined) {
    sysCampaign = properties.campaign;
  }
  if (properties.mediaSource !== null && properties.mediaSource !== undefined) {
    sysMediaSource = properties.mediaSource;
  }
  if (properties.channel !== null && properties.channel !== undefined) {
    sysChannel = properties.channel;
  }
  if (properties.contextUtmSource !== null && properties.contextUtmSource !== undefined) {
    sysContextUtmSource = properties.contextUtmSource;
  }
  if (properties.contextUtmContent !== null && properties.contextUtmContent !== undefined) {
    sysContextUtmContent = properties.contextUtmContent;
  }
  if (properties.offer !== null && properties.offer !== undefined) {
    sysOffer = properties.offer;
  }
  if (properties.contextUtmTerm !== null && properties.contextUtmTerm !== undefined) {
    sysContextUtmTerm = properties.contextUtmTerm;
  }
  if (properties.connectionType !== null && properties.connectionType !== undefined) {
    sysConnectionType = properties.connectionType;
  }
  if (properties.isOnline !== null && properties.isOnline !== undefined) {
    sysIsOnline = properties.isOnline;
  }
}

let Www: any;
let GoogleTagManager: any;

export function initAvo(options: {env: AvoEnv; webDebugger?: boolean;
  webDebuggerOptions?: webDebuggerOptions; strict?: boolean; noop?: boolean;
  reportFailureAs?: 'error' | 'warn' | 'log'; inspector?: AvoInspector;
  avoLogger?: AvoLogger},
  systemProperties: {contextDeviceType: ContextDeviceTypeValueType;
  contextLibraryName: ContextLibraryNameValueType;
  contextLibraryVersion: string; source: SourceValueType;
  acquisitionChannel: string | null | undefined;
  marketingTitle: string | null | undefined;
  contextUtmCampaign: string | null | undefined;
  contextUtmMedium: string | null | undefined;
  tags: string | null | undefined; campaign: string | null | undefined;
  mediaSource: string | null | undefined; channel: string | null | undefined;
  contextUtmSource: string | null | undefined;
  contextUtmContent: string | null | undefined;
  offer: string | null | undefined;
  contextUtmTerm: string | null | undefined;
  connectionType: string | null | undefined;
  isOnline: boolean | null | undefined}, destinationOptions: any,
  WwwDestination: CustomDestination,
  GoogleTagManagerDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }

  setSystemProperties(systemProperties);

  destinationOptions = destinationOptions || {};

  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    if (__AVO_ENV__ === AvoEnv.Staging) {
    }

    Www = WwwDestination;
    if (__AVO_ENV__ === 'prod') {
      Www && Www.make && Www.make(__AVO_ENV__, "xMYMn0uDmjA6VWmoWC2C9REj5Rb5Q4h2");
    } else if (__AVO_ENV__ === 'dev') {
      Www && Www.make && Www.make(__AVO_ENV__, "nyOkdlzUIR8oQdssiYIe1LLbGxN9Pweb");
    } else {
      console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for www. Head to destination settings in Avo to set a staging key.");
      Www && Www.make && Www.make(__AVO_ENV__, null);
    }

    GoogleTagManager = GoogleTagManagerDestination;
    if (__AVO_ENV__ === 'prod') {
      GoogleTagManager && GoogleTagManager.make && GoogleTagManager.make(__AVO_ENV__, null);
    } else if (__AVO_ENV__ === 'dev') {
      GoogleTagManager && GoogleTagManager.make && GoogleTagManager.make(__AVO_ENV__, null);
    } else {
      GoogleTagManager && GoogleTagManager.make && GoogleTagManager.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface UserLoggedInProperties {
  userId_: string;
  provider: ProviderValueType;
  origin: string;
  email: string | null | undefined;
  firstName: string | null | undefined;
  timeZone: string | null | undefined;
}
/**
 * User Logged In: When a user authenticates successfully and logs in.
 *
 * @param properties the properties associatied with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.provider: This property tell us how the user login or sign up. The option are 'Facebook', 'Twitter', 'Google', or 'Email'.
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 * @param properties.email: User Email Address
 * @param properties.firstName: User First Name
 * @param properties.timeZone: User Time Zone
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/xksL57iw3}
 */
export function userLoggedIn(properties: UserLoggedInProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "oxNaqYKbM", name: "provider", value: properties.provider});
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.email !== undefined && properties.email !== null ?
    userPropertiesArray.push({id: "lIwV03dVXL", name: "email", value: properties.email}) :
    userPropertiesArray.push({id: "lIwV03dVXL", name: "email", value: null});
  properties.firstName !== undefined && properties.firstName !== null ?
    userPropertiesArray.push({id: "_hUrpgRH9q", name: "first_name", value: properties.firstName}) :
    userPropertiesArray.push({id: "_hUrpgRH9q", name: "first_name", value: null});
  properties.timeZone !== undefined && properties.timeZone !== null ?
    userPropertiesArray.push({id: "CvPixbvrIQ", name: "time_zone", value: properties.timeZone}) :
    userPropertiesArray.push({id: "CvPixbvrIQ", name: "time_zone", value: null});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "xksL57iw3", "09ae90e9594b40d7792ccaface3c253ca4980f669add1dcca7a7359308d44eba", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Logged In", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("xksL57iw3", "User Logged In", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Logged In", eventProperties, "xksL57iw3", "09ae90e9594b40d7792ccaface3c253ca4980f669add1dcca7a7359308d44eba");
    }
    // destination Www
    Www.identify(properties.userId_);
    Www.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    Www.logEvent("User Logged In", (Object as any).assign({}, eventProperties));

  } else {
    // do nothing
  }
}

export interface UserCreatedProperties {
  userId_: string;
  provider: ProviderValueType;
  email: string | null | undefined;
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  timeZone: string | null | undefined;
  gender: string | null | undefined;
  createdAt: string | null | undefined;
}
/**
 * User Created: When a user successfully creates their Beek account on the Signup page.
 *
 * @param properties the properties associatied with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.provider: This property tell us how the user login or sign up. The option are 'Facebook', 'Twitter', 'Google', or 'Email'.
 * @param properties.email: User Email Address
 * @param properties.firstName: User First Name
 * @param properties.lastName: User Last Name
 * @param properties.timeZone: User Time Zone
 * @param properties.gender: User Gender
 * @param properties.createdAt: User Creation Date
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/hircW5tka}
 */
export function userCreated(properties: UserCreatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "oxNaqYKbM", name: "provider", value: properties.provider});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.email !== undefined && properties.email !== null ?
    userPropertiesArray.push({id: "lIwV03dVXL", name: "email", value: properties.email}) :
    userPropertiesArray.push({id: "lIwV03dVXL", name: "email", value: null});
  properties.firstName !== undefined && properties.firstName !== null ?
    userPropertiesArray.push({id: "_hUrpgRH9q", name: "first_name", value: properties.firstName}) :
    userPropertiesArray.push({id: "_hUrpgRH9q", name: "first_name", value: null});
  properties.lastName !== undefined && properties.lastName !== null ?
    userPropertiesArray.push({id: "2_fKlYLJq_", name: "last_name", value: properties.lastName}) :
    userPropertiesArray.push({id: "2_fKlYLJq_", name: "last_name", value: null});
  properties.timeZone !== undefined && properties.timeZone !== null ?
    userPropertiesArray.push({id: "CvPixbvrIQ", name: "time_zone", value: properties.timeZone}) :
    userPropertiesArray.push({id: "CvPixbvrIQ", name: "time_zone", value: null});
  properties.gender !== undefined && properties.gender !== null ?
    userPropertiesArray.push({id: "CMuOWa_P_x", name: "gender", value: properties.gender}) :
    userPropertiesArray.push({id: "CMuOWa_P_x", name: "gender", value: null});
  properties.createdAt !== undefined && properties.createdAt !== null ?
    userPropertiesArray.push({id: "o87QiPpxEc", name: "created_at", value: properties.createdAt}) :
    userPropertiesArray.push({id: "o87QiPpxEc", name: "created_at", value: null});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "hircW5tka", "67d50b6fb2e7b98b8b3fa09e93295ecc0a20c304bddb7ba86991fe6c3a0a05c1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Created", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("hircW5tka", "User Created", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Created", eventProperties, "hircW5tka", "67d50b6fb2e7b98b8b3fa09e93295ecc0a20c304bddb7ba86991fe6c3a0a05c1");
    }
    // destination Www
    Www.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    Www.logEvent("User Created", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    GoogleTagManager.logEvent("User Created", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LogOutButtonPressedProperties {
  origin: string;
}
/**
 * Log Out Button Pressed: When a user press the button to end their current session.
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/PEaKEQSzi}
 */
export function logOutButtonPressed(properties: LogOutButtonPressedProperties
  ) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "PEaKEQSzi", "fa2b36653c2fdefb976615e278402d708a724dd5b523ccfc9156897edd5a04fc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Log Out Button Pressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("PEaKEQSzi", "Log Out Button Pressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Log Out Button Pressed", eventProperties, "PEaKEQSzi", "fa2b36653c2fdefb976615e278402d708a724dd5b523ccfc9156897edd5a04fc");
    }
    // destination Www
    Www.logEvent("Log Out Button Pressed", (Object as any).assign({}, eventProperties));

  } else {
    // do nothing
  }
}

export interface LogOutConfirmedProperties {
  origin: string;
}
/**
 * Log Out Confirmed: When the user's current session is successfully ended.
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/advEvpFyo}
 */
export function logOutConfirmed(properties: LogOutConfirmedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "advEvpFyo", "076083fd33c553c2f22f7ed3d4b41597c89268220b9da23a9d8292b17e095961", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Log Out Confirmed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("advEvpFyo", "Log Out Confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Log Out Confirmed", eventProperties, "advEvpFyo", "076083fd33c553c2f22f7ed3d4b41597c89268220b9da23a9d8292b17e095961");
    }
    // destination Www
    Www.logEvent("Log Out Confirmed", (Object as any).assign({}, eventProperties));
    Www.unidentify();

  } else {
    // do nothing
  }
}

export interface ExperimentRenderedProperties {
  experimentName: string | null | undefined;
  experimentVariant: string | null | undefined;
  experimentEnvironment: string;
}
/**
 * Experiment Rendered: This event is triggered when a user gets to an experiment on the app.
 *
 * @param properties the properties associatied with this event
 * @param properties.experimentName: The name of the experiment. This is usually the name of a SPEC in pascal case, and the experiment version number. For example: Move CTA, V.1
 * @param properties.experimentVariant: The variant rendered to the user. This usually is 'Control' or 'B'.
 * @param properties.experimentEnvironment: The environment in which the experiment was conducted (e.g., development, staging, production)
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/Vby_XadJN}
 */
export function experimentRendered(properties: ExperimentRenderedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.experimentName !== undefined && properties.experimentName !== null ?
    eventPropertiesArray.push({id: "jbWDoy3Tm", name: "experiment_name", value: properties.experimentName}) :
    eventPropertiesArray.push({id: "jbWDoy3Tm", name: "experiment_name", value: null});
  properties.experimentVariant !== undefined && properties.experimentVariant !== null ?
    eventPropertiesArray.push({id: "IlSE48eXt", name: "experiment_variant", value: properties.experimentVariant}) :
    eventPropertiesArray.push({id: "IlSE48eXt", name: "experiment_variant", value: null});
  eventPropertiesArray.push({id: "XkNSwUBmu-", name: "experiment_environment", value: properties.experimentEnvironment});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Vby_XadJN", "98b31cd69f4e3692ede50460a94369cebe46fa2faf8d557a2ad2bbf3e0c76573", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Experiment Rendered", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Vby_XadJN", "Experiment Rendered", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Experiment Rendered", eventProperties, "Vby_XadJN", "98b31cd69f4e3692ede50460a94369cebe46fa2faf8d557a2ad2bbf3e0c76573");
    }
    // destination Www
    Www.logEvent("Experiment Rendered", (Object as any).assign({}, eventProperties));

  } else {
    // do nothing
  }
}

export interface SubscriptionStartErrorTriggeredProperties {
  origin: string;
  errorReason: string;
}
/**
 * Subscription Start Error Triggered: When an error occurs while trying to subscribe a user via an in-app purchase.
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 * @param properties.errorReason: This property send the why wasn't possible to finish the action the user wanted to do.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/BBjTwPo0v}
 */
export function subscriptionStartErrorTriggered(
  properties: SubscriptionStartErrorTriggeredProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "SX0Xsr_oM", name: "error_reason", value: properties.errorReason});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "BBjTwPo0v", "34adc56462d18afebc45fc54fc2950580b2358b3e8dfbb8b2e9dc2da8a2279ad", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Start Error Triggered", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("BBjTwPo0v", "Subscription Start Error Triggered", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Start Error Triggered", eventProperties, "BBjTwPo0v", "34adc56462d18afebc45fc54fc2950580b2358b3e8dfbb8b2e9dc2da8a2279ad");
    }
    // destination Www
    Www.logEvent("Subscription Start Error Triggered", (Object as any).assign({}, eventProperties));

  } else {
    // do nothing
  }
}

export interface SubscriptionSignUpScreenClosedProperties {
  audiobookId: number | null | undefined;
}
/**
 * Subscription Sign Up Screen Closed: When a user declines to subscribe while on the Start Subscription screen, either by closing the in-app purchase dialogue or clicking "Ahora no" / "Not now" button on web.
 *
 * @param properties the properties associatied with this event
 * @param properties.audiobookId: If the Scene is a Book Scene and the Book is related to an Audiobook, this property displays the ID of the audiobook as stored in the table `audiobooks`Beek's Data Base.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/Sp8OHojj1}
 */
export function subscriptionSignUpScreenClosed(
  properties: SubscriptionSignUpScreenClosedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.audiobookId !== undefined && properties.audiobookId !== null ?
    eventPropertiesArray.push({id: "FVGzxfq0-", name: "audiobook_id", value: properties.audiobookId}) :
    eventPropertiesArray.push({id: "FVGzxfq0-", name: "audiobook_id", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Sp8OHojj1", "5e6d15c88f4012b695a9efbf1641c24bc5f517154eae766c05620a1152b9f1dc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Sign Up Screen Closed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Sp8OHojj1", "Subscription Sign Up Screen Closed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Sign Up Screen Closed", eventProperties, "Sp8OHojj1", "5e6d15c88f4012b695a9efbf1641c24bc5f517154eae766c05620a1152b9f1dc");
    }
    // destination Www
    Www.logEvent("Subscription Sign Up Screen Closed", (Object as any).assign({}, eventProperties));

  } else {
    // do nothing
  }
}

export interface AddPaymentMethodButtonPressedProperties {
  origin: string;
}
/**
 * Add Payment Method Button Pressed: User presses button to add a new payment method
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/jFoQimMKFZ}
 */
export function addPaymentMethodButtonPressed(
  properties: AddPaymentMethodButtonPressedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "jFoQimMKFZ", "de6f2f321f7b810ae09f808f4ebca629990f56af42485d33f6223fd06ef88de9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Add Payment Method Button Pressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("jFoQimMKFZ", "Add Payment Method Button Pressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Add Payment Method Button Pressed", eventProperties, "jFoQimMKFZ", "de6f2f321f7b810ae09f808f4ebca629990f56af42485d33f6223fd06ef88de9");
    }
    // destination Www
    Www.logEvent("Add Payment Method Button Pressed", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Add Payment Method Button Pressed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AddPaymentMethodConfirmedProperties {
  origin: string;
}
/**
 * Add Payment Method Confirmed: User’s payment method successfully added.
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/EWOoAwXSP9}
 */
export function addPaymentMethodConfirmed(
  properties: AddPaymentMethodConfirmedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "EWOoAwXSP9", "0fd010f99d2c260848be3a1989cc7186511ba441406e76067088928032981eb9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Add Payment Method Confirmed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("EWOoAwXSP9", "Add Payment Method Confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Add Payment Method Confirmed", eventProperties, "EWOoAwXSP9", "0fd010f99d2c260848be3a1989cc7186511ba441406e76067088928032981eb9");
    }
    // destination Www
    Www.logEvent("Add Payment Method Confirmed", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Add Payment Method Confirmed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AddPaymentMethodErrorProperties {
  origin: string;
  errorReason: string;
  errorMessage: string;
}
/**
 * Add Payment Method Error: User tried to add a payment method, but it failed with an error
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 * @param properties.errorReason: This property send the why wasn't possible to finish the action the user wanted to do.
 * @param properties.errorMessage: This property send the error message that is shown to the user. Sometimes Twitter, Google, or Facebook sends this message, and sometimes this information is sent by Beek.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/mRal5QD1zG}
 */
export function addPaymentMethodError(
  properties: AddPaymentMethodErrorProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "SX0Xsr_oM", name: "error_reason", value: properties.errorReason});
  eventPropertiesArray.push({id: "x2ihd067l", name: "error_message", value: properties.errorMessage});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "mRal5QD1zG", "dc9549a339ae7abbb708897f2c9ed436d85149b27ea04f7fc18ea6e533160e25", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Add Payment Method Error", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("mRal5QD1zG", "Add Payment Method Error", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Add Payment Method Error", eventProperties, "mRal5QD1zG", "dc9549a339ae7abbb708897f2c9ed436d85149b27ea04f7fc18ea6e533160e25");
    }
    // destination Www
    Www.logEvent("Add Payment Method Error", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Add Payment Method Error", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionFlowStartedProperties {
  origin: string;
}
/**
 * Subscription Flow Started: When a user first reaches the Start Subscription page.

 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/wJiTfHlqae}
 */
export function subscriptionFlowStarted(
  properties: SubscriptionFlowStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "wJiTfHlqae", "4d0e13a18d5651b36154af1bfa5d2716f0399bdcc09bd9c837a90a9daa9391ed", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Flow Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("wJiTfHlqae", "Subscription Flow Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Flow Started", eventProperties, "wJiTfHlqae", "4d0e13a18d5651b36154af1bfa5d2716f0399bdcc09bd9c837a90a9daa9391ed");
    }
    // destination Www
    Www.logEvent("Subscription Flow Started", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Subscription Flow Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionPurchasedProperties {
  origin: string;
  subscriptionId: string;
  providerType: string | null | undefined;
}
/**
 * Subscription Purchased: When a subscription is successfully purchased by a user.
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 * @param properties.subscriptionId: The ID of the subscription object that was just created
 * @param properties.providerType: The type of subscription created (e.g., Apple, Android, Stripe, &c.)
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/HV9wxEIwsq}
 */
export function subscriptionPurchased(
  properties: SubscriptionPurchasedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "PnsDIx5EbJ", name: "subscription_id", value: properties.subscriptionId});
  properties.providerType !== undefined && properties.providerType !== null ?
    eventPropertiesArray.push({id: "QxCgkKvRFz", name: "provider_type", value: properties.providerType}) :
    eventPropertiesArray.push({id: "QxCgkKvRFz", name: "provider_type", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "HV9wxEIwsq", "a8d176c5f47f5adf2871e3f0ce9cb9b628412ee1efcb6e0697537618b58d0ce3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Purchased", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("HV9wxEIwsq", "Subscription Purchased", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Purchased", eventProperties, "HV9wxEIwsq", "a8d176c5f47f5adf2871e3f0ce9cb9b628412ee1efcb6e0697537618b58d0ce3");
    }
    // destination Www
    Www.logEvent("Subscription Purchased", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Subscription Purchased", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FreeTrialStartedProperties {
  origin: string;
  subscriptionId: string;
  providerType: string | null | undefined;
  planType: PlanTypeValueType | null | undefined;
}
/**
 * Free Trial Started: When a user successfully subscribes for the first time and begins their free trial period.
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 * @param properties.subscriptionId: The ID of the subscription object that was just created
 * @param properties.providerType: The type of subscription created (e.g., Apple, Android, Stripe, &c.)
 * @param properties.planType: Will receive monthly_plan or yearly_plan as a string.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/77BWTPA26e}
 */
export function freeTrialStarted(properties: FreeTrialStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "PnsDIx5EbJ", name: "subscription_id", value: properties.subscriptionId});
  properties.providerType !== undefined && properties.providerType !== null ?
    eventPropertiesArray.push({id: "QxCgkKvRFz", name: "provider_type", value: properties.providerType}) :
    eventPropertiesArray.push({id: "QxCgkKvRFz", name: "provider_type", value: null});
  properties.planType !== undefined && properties.planType !== null ?
    eventPropertiesArray.push({id: "h18l4Rc3i", name: "plan_type", value: properties.planType}) :
    eventPropertiesArray.push({id: "h18l4Rc3i", name: "plan_type", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "77BWTPA26e", "ff2667218b25d1a258ed9b39121a2d8055fb664a0c9c6291d1b99031e0dedd59", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Free Trial Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("77BWTPA26e", "Free Trial Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Free Trial Started", eventProperties, "77BWTPA26e", "ff2667218b25d1a258ed9b39121a2d8055fb664a0c9c6291d1b99031e0dedd59");
    }
    // destination Www
    Www.logEvent("Free Trial Started", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Free Trial Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionPaymentFieldFocusedProperties {
  fieldName: FieldNameValueType;
  origin: string;
}
/**
 * Subscription Payment Field Focused: When a user focuses either payment field on the Start Subscription form.
 *
 * @param properties the properties associatied with this event
 * @param properties.fieldName: This property capture the field where the user made focus.
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/NbHIkZN52W}
 */
export function subscriptionPaymentFieldFocused(
  properties: SubscriptionPaymentFieldFocusedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "L4rYPm_-y", name: "field_name", value: properties.fieldName});
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "NbHIkZN52W", "c97c9374b814cd7e917b42fd2360f9af0bffca3d3e5aece1eb730ff21dd70187", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Payment Field Focused", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("NbHIkZN52W", "Subscription Payment Field Focused", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Payment Field Focused", eventProperties, "NbHIkZN52W", "c97c9374b814cd7e917b42fd2360f9af0bffca3d3e5aece1eb730ff21dd70187");
    }
    // destination Www
    Www.logEvent("Subscription Payment Field Focused", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Subscription Payment Field Focused", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionPurchaseErrorTriggeredProperties {
  errorReason: string;
  errorMessage: string;
  providerType: string | null | undefined;
}
/**
 * Subscription Purchase Error Triggered: When the mutation for purchasing a subscription throws an error.
 *
 * @param properties the properties associatied with this event
 * @param properties.errorReason: This property send the why wasn't possible to finish the action the user wanted to do.
 * @param properties.errorMessage: This property send the error message that is shown to the user. Sometimes Twitter, Google, or Facebook sends this message, and sometimes this information is sent by Beek.
 * @param properties.providerType: The type of subscription created (e.g., Apple, Android, Stripe, &c.)
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/X0sXXFlXXd}
 */
export function subscriptionPurchaseErrorTriggered(
  properties: SubscriptionPurchaseErrorTriggeredProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "SX0Xsr_oM", name: "error_reason", value: properties.errorReason});
  eventPropertiesArray.push({id: "x2ihd067l", name: "error_message", value: properties.errorMessage});
  properties.providerType !== undefined && properties.providerType !== null ?
    eventPropertiesArray.push({id: "QxCgkKvRFz", name: "provider_type", value: properties.providerType}) :
    eventPropertiesArray.push({id: "QxCgkKvRFz", name: "provider_type", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "X0sXXFlXXd", "9ea6ee5a7f80be582351e2e536b2201bab00872399bc6107912b205f1489a42a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Purchase Error Triggered", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("X0sXXFlXXd", "Subscription Purchase Error Triggered", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Purchase Error Triggered", eventProperties, "X0sXXFlXXd", "9ea6ee5a7f80be582351e2e536b2201bab00872399bc6107912b205f1489a42a");
    }
    // destination Www
    Www.logEvent("Subscription Purchase Error Triggered", (Object as any).assign({}, eventProperties));

  } else {
    // do nothing
  }
}

export interface AudiobookSavedConfirmedProperties {
  userId_: string;
  audiobookId: number | null | undefined;
  productType: string;
  origin: string;
  isBeekOriginal: boolean | null | undefined;
  userStatus: string;
  authors: string | null | undefined;
  audiobookLanguage: string | null | undefined;
  bisacCodes: string | null | undefined;
  audiobookRuntimeSeconds: number | null | undefined;
  firstBisacCode: string | null | undefined;
  context: string | null | undefined;
  publisher: string | null | undefined;
  contentId: number | null | undefined;
}
/**
 * Audiobook Saved Confirmed: When a user adds an audiobook to their library successfully. Also called during initial onboarding flow when picking their first audiobooks for their library.
 *
 * @param properties the properties associatied with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.audiobookId: If the Scene is a Book Scene and the Book is related to an Audiobook, this property displays the ID of the audiobook as stored in the table `audiobooks`Beek's Data Base.
 * @param properties.productType: This is the type of product that we are selling
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 * @param properties.isBeekOriginal: To know if the audiobook loaded is a Beek original
 * @param properties.userStatus: This property describes the status of the user in Beek. If he doesn't have an active subscription the status is 'User', if he is in the free trial period the status will be 'Free Trial' and if he paid at least once and his subscription is not cancel when he made the event the status will be 'Paying Subscriber'.
 * @param properties.authors: The authors for the audiobook, formate as a string separating the names by commas
 * @param properties.audiobookLanguage: The language of the audiobook.
 * @param properties.bisacCodes: List of bisac codes separated by space and comma
 * @param properties.audiobookRuntimeSeconds: The total runtime of the audiobook in seconds
 * @param properties.firstBisacCode: The first bisac code for this audiobook
 * @param properties.context: If we want Tamber not include this event in their recommendation algorithm
 * @param properties.publisher: audioContent publisher
 * @param properties.contentId: The ID corresponding to some content (Audiobook, Podcast, etc). Note this is NOT an Audiobook ID
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/jtYKXZZqdh}
 */
export function audiobookSavedConfirmed(
  properties: AudiobookSavedConfirmedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.audiobookId !== undefined && properties.audiobookId !== null ?
    eventPropertiesArray.push({id: "FVGzxfq0-", name: "audiobook_id", value: properties.audiobookId}) :
    eventPropertiesArray.push({id: "FVGzxfq0-", name: "audiobook_id", value: null});
  eventPropertiesArray.push({id: "Dcg6Tbqhd", name: "product_type", value: properties.productType});
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  properties.isBeekOriginal !== undefined && properties.isBeekOriginal !== null ?
    eventPropertiesArray.push({id: "NXNG1jn9P", name: "is_beek_original", value: properties.isBeekOriginal}) :
    eventPropertiesArray.push({id: "NXNG1jn9P", name: "is_beek_original", value: null});
  properties.authors !== undefined && properties.authors !== null ?
    eventPropertiesArray.push({id: "9o2cZplFe9", name: "authors", value: properties.authors}) :
    eventPropertiesArray.push({id: "9o2cZplFe9", name: "authors", value: null});
  properties.audiobookLanguage !== undefined && properties.audiobookLanguage !== null ?
    eventPropertiesArray.push({id: "hyO5R_aFzR", name: "audiobook_language", value: properties.audiobookLanguage}) :
    eventPropertiesArray.push({id: "hyO5R_aFzR", name: "audiobook_language", value: null});
  properties.bisacCodes !== undefined && properties.bisacCodes !== null ?
    eventPropertiesArray.push({id: "as1_epOIwE", name: "bisac_codes", value: properties.bisacCodes}) :
    eventPropertiesArray.push({id: "as1_epOIwE", name: "bisac_codes", value: null});
  properties.audiobookRuntimeSeconds !== undefined && properties.audiobookRuntimeSeconds !== null ?
    eventPropertiesArray.push({id: "uXg3itKMDD", name: "audiobook_runtime_seconds", value: properties.audiobookRuntimeSeconds}) :
    eventPropertiesArray.push({id: "uXg3itKMDD", name: "audiobook_runtime_seconds", value: null});
  properties.firstBisacCode !== undefined && properties.firstBisacCode !== null ?
    eventPropertiesArray.push({id: "9w6WLjFD8i", name: "first_bisac_code", value: properties.firstBisacCode}) :
    eventPropertiesArray.push({id: "9w6WLjFD8i", name: "first_bisac_code", value: null});
  properties.context !== undefined && properties.context !== null ?
    eventPropertiesArray.push({id: "dAn0N_2Zin", name: "context", value: properties.context}) :
    eventPropertiesArray.push({id: "dAn0N_2Zin", name: "context", value: null});
  properties.publisher !== undefined && properties.publisher !== null ?
    eventPropertiesArray.push({id: "NkZLW1R76", name: "publisher", value: properties.publisher}) :
    eventPropertiesArray.push({id: "NkZLW1R76", name: "publisher", value: null});
  properties.contentId !== undefined && properties.contentId !== null ?
    eventPropertiesArray.push({id: "t8mwVBHKDa", name: "content_id", value: properties.contentId}) :
    eventPropertiesArray.push({id: "t8mwVBHKDa", name: "content_id", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  userPropertiesArray.push({id: "fpmpsQ_N3", name: "user_status", value: properties.userStatus});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "jtYKXZZqdh", "ae4a7747d351b44f57f5cc83408b3a8154d70b055570fcf59ef1b1f73c614c65", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Audiobook Saved Confirmed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("jtYKXZZqdh", "Audiobook Saved Confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Audiobook Saved Confirmed", eventProperties, "jtYKXZZqdh", "ae4a7747d351b44f57f5cc83408b3a8154d70b055570fcf59ef1b1f73c614c65");
    }
    // destination Www
    Www.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    Www.logEvent("Audiobook Saved Confirmed", (Object as any).assign({}, eventProperties));

  } else {
    // do nothing
  }
}

export interface OnboardingFlowStartedProperties {
  origin: string | null | undefined;
}
/**
 * Onboarding Flow Started: When a new user starts the Beek onboarding flow immediately after their account is successfully created.
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/NzXoBokhMn}
 */
export function onboardingFlowStarted(
  properties: OnboardingFlowStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.origin !== undefined && properties.origin !== null ?
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin}) :
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "NzXoBokhMn", "9b171d5d07b7b399a0b4b906631f25e3ed076fbe1878c8a8d437bfb726ff3021", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Flow Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("NzXoBokhMn", "Onboarding Flow Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Flow Started", eventProperties, "NzXoBokhMn", "9b171d5d07b7b399a0b4b906631f25e3ed076fbe1878c8a8d437bfb726ff3021");
    }
    // destination Www
    Www.logEvent("Onboarding Flow Started", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Onboarding Flow Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CategoryPickedProperties {
  categoryName: string;
  categoryId: number;
}
/**
 * Category Picked: Whenever a user clicks to pick (or change) their preferred onboarding category. May be triggered multiple times by the same user on the same page.
 *
 * When to trigger this event:
 * 1. Every time the user clicks a new Path / Onboarding category. Can be triggered multiple times on the same page if the user clicks different ones.
 * View in Avo: https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/O5wUnpCAKV/trigger/zmWLtxedr
 *
 * @param properties the properties associatied with this event
 * @param properties.categoryName: This is the name of a Category
 * @param properties.categoryId: The ID for the onboarding path category selected by a user during the onboarding flow.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/O5wUnpCAKV}
 */
export function categoryPicked(properties: CategoryPickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "MYhWjSvMlG", name: "category_name", value: properties.categoryName});
  eventPropertiesArray.push({id: "CRCOG1iQE2", name: "category_id", value: properties.categoryId});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "O5wUnpCAKV", "91420d1ed9eb491f160ba8cf4604d6c248343246414a9922d390cae8d8b18b2b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Category Picked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("O5wUnpCAKV", "Category Picked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Category Picked", eventProperties, "O5wUnpCAKV", "91420d1ed9eb491f160ba8cf4604d6c248343246414a9922d390cae8d8b18b2b");
    }
    // destination Www
    Www.logEvent("Category Picked", (Object as any).assign({}, eventProperties));

  } else {
    // do nothing
  }
}

export interface OnboardingContinueButtonPressedProperties {
  origin: string | null | undefined;
}
/**
 * Onboarding Continue Button Pressed: When a user clicks the Continue button to proceed to the next onboarding step. This event includes the page the Continue button was clicked on.
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/pXcoZ6DLhP}
 */
export function onboardingContinueButtonPressed(
  properties: OnboardingContinueButtonPressedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.origin !== undefined && properties.origin !== null ?
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin}) :
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "pXcoZ6DLhP", "bd1e37acf1c1af313f1ce8568206e6addf261ac29bbce0b434490656bcea563e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Continue Button Pressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("pXcoZ6DLhP", "Onboarding Continue Button Pressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Continue Button Pressed", eventProperties, "pXcoZ6DLhP", "bd1e37acf1c1af313f1ce8568206e6addf261ac29bbce0b434490656bcea563e");
    }
    // destination Www
    Www.logEvent("Onboarding Continue Button Pressed", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Onboarding Continue Button Pressed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingSkipButtonPressedProperties {
  origin: string | null | undefined;
}
/**
 * Onboarding Skip Button Pressed: When the user clicks the "Ahora no" / "Not now" button to skip an optional onboarding step.
 *
 * When to trigger this event:
 * 1. Set Goal onboarding step skipped via the "Ahora no" / "Not now" button.
 * View in Avo: https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/yxCAFBkRJN/trigger/tFQ5D_dni
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/yxCAFBkRJN}
 */
export function onboardingSkipButtonPressed(
  properties: OnboardingSkipButtonPressedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.origin !== undefined && properties.origin !== null ?
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin}) :
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "yxCAFBkRJN", "10e98087f7b6a533e0b2541d57e0be95353091c07e26b7d22359ff3170b01564", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Skip Button Pressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("yxCAFBkRJN", "Onboarding Skip Button Pressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Skip Button Pressed", eventProperties, "yxCAFBkRJN", "10e98087f7b6a533e0b2541d57e0be95353091c07e26b7d22359ff3170b01564");
    }
    // destination Www
    Www.logEvent("Onboarding Skip Button Pressed", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Onboarding Skip Button Pressed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingFlowFinishedProperties {
  origin: string;
}
/**
 * Onboarding Flow Finished: When a new user successfully completes the Onboarding flow for new Beek accounts. The Start Subscription flow begins immediately after the Onboarding flow, so its event happens at the same time as this one.
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/gnUrN0d9z3}
 */
export function onboardingFlowFinished(
  properties: OnboardingFlowFinishedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "gnUrN0d9z3", "ee532559b008053c630e9d6fd303375602bc6a8b75ec56bed923222e374c8944", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Flow Finished", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("gnUrN0d9z3", "Onboarding Flow Finished", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Flow Finished", eventProperties, "gnUrN0d9z3", "ee532559b008053c630e9d6fd303375602bc6a8b75ec56bed923222e374c8944");
    }
    // destination Www
    Www.logEvent("Onboarding Flow Finished", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Onboarding Flow Finished", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AudiobookSamplePlayButtonPressedProperties {
  userId_: string;
  audiobookId: number | null | undefined;
  sampleRuntime: number;
  userStatus: string;
}
/**
 * Audiobook Sample Play Button Pressed: When a user clicks the Play button on an audiobook sample.
 *
 * @param properties the properties associatied with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.audiobookId: If the Scene is a Book Scene and the Book is related to an Audiobook, this property displays the ID of the audiobook as stored in the table `audiobooks`Beek's Data Base.
 * @param properties.sampleRuntime: The sample runtime
 * @param properties.userStatus: This property describes the status of the user in Beek. If he doesn't have an active subscription the status is 'User', if he is in the free trial period the status will be 'Free Trial' and if he paid at least once and his subscription is not cancel when he made the event the status will be 'Paying Subscriber'.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/Ftp_XuNRW-}
 */
export function audiobookSamplePlayButtonPressed(
  properties: AudiobookSamplePlayButtonPressedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.audiobookId !== undefined && properties.audiobookId !== null ?
    eventPropertiesArray.push({id: "FVGzxfq0-", name: "audiobook_id", value: properties.audiobookId}) :
    eventPropertiesArray.push({id: "FVGzxfq0-", name: "audiobook_id", value: null});
  eventPropertiesArray.push({id: "SjNUE2HIjI", name: "sample_runtime", value: properties.sampleRuntime});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  userPropertiesArray.push({id: "fpmpsQ_N3", name: "user_status", value: properties.userStatus});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Ftp_XuNRW-", "16fa6b9a4fbb1c4f54047140fb39ac9bffd3da7a35385c5b71c177c806bb9edf", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Audiobook Sample Play Button Pressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Ftp_XuNRW-", "Audiobook Sample Play Button Pressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Audiobook Sample Play Button Pressed", eventProperties, "Ftp_XuNRW-", "16fa6b9a4fbb1c4f54047140fb39ac9bffd3da7a35385c5b71c177c806bb9edf");
    }
    // destination Www
    Www.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    Www.logEvent("Audiobook Sample Play Button Pressed", (Object as any).assign({}, eventProperties));

  } else {
    // do nothing
  }
}

export interface AudiobookSamplePauseButtonPressedProperties {
  userId_: string;
  audiobookId: number | null | undefined;
  sampleRuntime: number;
  userStatus: string;
}
/**
 * Audiobook Sample Pause Button Pressed: When a user clicks the Pause button on a currently playing audiobook sample.
 *
 * @param properties the properties associatied with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.audiobookId: If the Scene is a Book Scene and the Book is related to an Audiobook, this property displays the ID of the audiobook as stored in the table `audiobooks`Beek's Data Base.
 * @param properties.sampleRuntime: The sample runtime
 * @param properties.userStatus: This property describes the status of the user in Beek. If he doesn't have an active subscription the status is 'User', if he is in the free trial period the status will be 'Free Trial' and if he paid at least once and his subscription is not cancel when he made the event the status will be 'Paying Subscriber'.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/eFI1eP3edu}
 */
export function audiobookSamplePauseButtonPressed(
  properties: AudiobookSamplePauseButtonPressedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.audiobookId !== undefined && properties.audiobookId !== null ?
    eventPropertiesArray.push({id: "FVGzxfq0-", name: "audiobook_id", value: properties.audiobookId}) :
    eventPropertiesArray.push({id: "FVGzxfq0-", name: "audiobook_id", value: null});
  eventPropertiesArray.push({id: "SjNUE2HIjI", name: "sample_runtime", value: properties.sampleRuntime});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  userPropertiesArray.push({id: "fpmpsQ_N3", name: "user_status", value: properties.userStatus});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "eFI1eP3edu", "41b2fa094ae647fc9f326b43b4e2208f8b4527ae182e7ab76d8d859289f2380d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Audiobook Sample Pause Button Pressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("eFI1eP3edu", "Audiobook Sample Pause Button Pressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Audiobook Sample Pause Button Pressed", eventProperties, "eFI1eP3edu", "41b2fa094ae647fc9f326b43b4e2208f8b4527ae182e7ab76d8d859289f2380d");
    }
    // destination Www
    Www.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    Www.logEvent("Audiobook Sample Pause Button Pressed", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    GoogleTagManager.logEvent("Audiobook Sample Pause Button Pressed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubscriptionPlanPickedProperties {
  origin: string;
  subscriptionPlanName: string | null | undefined;
}
/**
 * Subscription Plan Picked: When a user toggles between subscription plan versions (e.g., monthly to annual plan, or vice-versa)
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 * @param properties.subscriptionPlanName: The subscription name that the user purchased
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/S7Hv79G5hT}
 */
export function subscriptionPlanPicked(
  properties: SubscriptionPlanPickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  properties.subscriptionPlanName !== undefined && properties.subscriptionPlanName !== null ?
    eventPropertiesArray.push({id: "0GQm-Tzp3p", name: "subscription_plan_name", value: properties.subscriptionPlanName}) :
    eventPropertiesArray.push({id: "0GQm-Tzp3p", name: "subscription_plan_name", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "S7Hv79G5hT", "325884e4e34ae309229be3fe6f4fa3493496bd4a39f8a09933a819309fed17c0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subscription Plan Picked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("S7Hv79G5hT", "Subscription Plan Picked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subscription Plan Picked", eventProperties, "S7Hv79G5hT", "325884e4e34ae309229be3fe6f4fa3493496bd4a39f8a09933a819309fed17c0");
    }
    // destination Www
    Www.logEvent("Subscription Plan Picked", (Object as any).assign({}, eventProperties));

  } else {
    // do nothing
  }
}

export interface KeepSubscriptionButtonPressedProperties {
  origin: string;
}
/**
 * Keep Subscription Button Pressed: When a user in the Cancellation Flow decides to keep their subscription and makes Pame very happy
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/ESgTpW0t5S}
 */
export function keepSubscriptionButtonPressed(
  properties: KeepSubscriptionButtonPressedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ESgTpW0t5S", "fec7866170cb0d32953004b5b0439f2d021538e3ecfaae24c6ab0ad85a603236", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Keep Subscription Button Pressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ESgTpW0t5S", "Keep Subscription Button Pressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Keep Subscription Button Pressed", eventProperties, "ESgTpW0t5S", "fec7866170cb0d32953004b5b0439f2d021538e3ecfaae24c6ab0ad85a603236");
    }
    // destination Www
    Www.logEvent("Keep Subscription Button Pressed", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Keep Subscription Button Pressed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CancellationReasonPickedProperties {
  origin: string;
  userFeedback: string | null | undefined;
  reasonPicked: string;
}
/**
 * Cancellation Reason Picked: When the user picked her cancellation reason
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 * @param properties.userFeedback: The user feedback
 * @param properties.reasonPicked: The reason picked
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/f3MXa5kgMD}
 */
export function cancellationReasonPicked(
  properties: CancellationReasonPickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  properties.userFeedback !== undefined && properties.userFeedback !== null ?
    eventPropertiesArray.push({id: "LGPXDgZIM", name: "user_feedback", value: properties.userFeedback}) :
    eventPropertiesArray.push({id: "LGPXDgZIM", name: "user_feedback", value: null});
  eventPropertiesArray.push({id: "xp4CIwpYag", name: "reason_picked", value: properties.reasonPicked});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "f3MXa5kgMD", "51af93673c9ed7d3827c660885614512115491bf337175e6b552576ae4214d70", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Cancellation Reason Picked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("f3MXa5kgMD", "Cancellation Reason Picked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Cancellation Reason Picked", eventProperties, "f3MXa5kgMD", "51af93673c9ed7d3827c660885614512115491bf337175e6b552576ae4214d70");
    }
    // destination Www
    Www.logEvent("Cancellation Reason Picked", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Cancellation Reason Picked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface StartButtonPressedProperties {
  origin: string | null | undefined;
  userAgent: string;
  signupOfferSlug: string | null | undefined;
}
/**
 * Start Button Pressed: This event should not be sent to Segment. It would increase our segment costs

When a signed-out user clicks on the main "Probar Beek por 14 días" / "Try Beek for 14 Days" button on the landing page [https://beek.io/] to go to the Sign Up page and start the Onboarding Flow.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/jS8ubaSoFC/trigger/fSRIzzf9f
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 * @param properties.userAgent: Is the device user agent.
 * @param properties.signupOfferSlug: Sign up offer slug

 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/jS8ubaSoFC}
 */
export function startButtonPressed(properties: StartButtonPressedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.origin !== undefined && properties.origin !== null ?
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin}) :
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: null});
  eventPropertiesArray.push({id: "4sMZMryCs", name: "user_agent", value: properties.userAgent});
  properties.signupOfferSlug !== undefined && properties.signupOfferSlug !== null ?
    eventPropertiesArray.push({id: "BUOjoH5G1", name: "signup_offer_slug", value: properties.signupOfferSlug}) :
    eventPropertiesArray.push({id: "BUOjoH5G1", name: "signup_offer_slug", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "jS8ubaSoFC", "7f097a8a5bb90e4b1d546acfa71af0241a83d1e54d432b1e36f32421cf5e63ea", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Start Button Pressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("jS8ubaSoFC", "Start Button Pressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Start Button Pressed", eventProperties, "jS8ubaSoFC", "7f097a8a5bb90e4b1d546acfa71af0241a83d1e54d432b1e36f32421cf5e63ea");
    }
    // destination GoogleTagManager
    GoogleTagManager.logEvent("Start Button Pressed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SignupFlowStartedProperties {
  origin: string;
}
/**
 * Signup Flow Started: When a user begins the signup flow to create a new account.
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/Fq8L-r2R6r}
 */
export function signupFlowStarted(properties: SignupFlowStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Fq8L-r2R6r", "303fabacc14a625ca69377445f2718a7e235cda71ee2b97005bf910f5039ca18", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Signup Flow Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Fq8L-r2R6r", "Signup Flow Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Signup Flow Started", eventProperties, "Fq8L-r2R6r", "303fabacc14a625ca69377445f2718a7e235cda71ee2b97005bf910f5039ca18");
    }
    // destination GoogleTagManager
    GoogleTagManager.logEvent("Signup Flow Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface StartSubscriptionTrialButtonClickedProperties {
  origin: string;
}
/**
 * Start Subscription Trial Button Clicked: When a user clicks the Start Subscription button in beek.io/subscription/start. This event is triggered whether the user is starting their free trial or renewing their prior subscription.
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/iotBAEl8qU}
 */
export function startSubscriptionTrialButtonClicked(
  properties: StartSubscriptionTrialButtonClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "iotBAEl8qU", "f5e316327ea06c4f58adebab04af7d12f335f7b21e03d7b9438a61734cd7ad41", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Start Subscription Trial Button Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("iotBAEl8qU", "Start Subscription Trial Button Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Start Subscription Trial Button Clicked", eventProperties, "iotBAEl8qU", "f5e316327ea06c4f58adebab04af7d12f335f7b21e03d7b9438a61734cd7ad41");
    }
    // destination Www
    Www.logEvent("Start Subscription Trial Button Clicked", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Start Subscription Trial Button Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingFlowAbortedProperties {
  referrer: string;
}
/**
 * Onboarding Flow Aborted: When a user exits the onboarding flow before finishing all steps. This will cause them to start again from the beginning of the Onboarding Flow when they try again.
 *
 * When to trigger this event:
 * 1. When a user clicks on the Beek logo in the header bar during the Onboarding Flow.
 * View in Avo: https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/7H7DWY_Jlf/trigger/50rmcuDdB
 *
 * @param properties the properties associatied with this event
 * @param properties.referrer:  This property sends the name of the last scene (screen) loaded (before the current one).
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/7H7DWY_Jlf}
 */
export function onboardingFlowAborted(
  properties: OnboardingFlowAbortedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "GnM26pXpf", name: "referrer", value: properties.referrer});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "7H7DWY_Jlf", "d95dbb5fc7863c963c5aeb64d2321a2d6b43838b993690958d4f5755d5dcca22", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Flow Aborted", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("7H7DWY_Jlf", "Onboarding Flow Aborted", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Flow Aborted", eventProperties, "7H7DWY_Jlf", "d95dbb5fc7863c963c5aeb64d2321a2d6b43838b993690958d4f5755d5dcca22");
    }
    // destination Www
    Www.logEvent("Onboarding Flow Aborted", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Onboarding Flow Aborted", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Web Player Button Pressed: When a user clicks the Use Beek on my computer button in the new beek.io/home page.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/Dg-fYBkF9}
 */
export function webPlayerButtonPressed() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Dg-fYBkF9", "64ad89ed1e6298269e4150f3ce8cfb3b7077d3bb8fb1923138c4a7d80517ab1e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Web Player Button Pressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Dg-fYBkF9", "Web Player Button Pressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Web Player Button Pressed", eventProperties, "Dg-fYBkF9", "64ad89ed1e6298269e4150f3ce8cfb3b7077d3bb8fb1923138c4a7d80517ab1e");
    }
    // destination Www
    Www.logEvent("Web Player Button Pressed", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Web Player Button Pressed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BannerFlowStartedProperties {
  origin: string;
}
/**
 * Banner Flow Started: When a user reaches beek.io/download-app page through the web player banner
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/fIlQMjt5lY}
 */
export function bannerFlowStarted(properties: BannerFlowStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "fIlQMjt5lY", "43e88f200ec92d378bb53a6994d8f012021cb56df443ee826fd90535059b3e32", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Banner Flow Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("fIlQMjt5lY", "Banner Flow Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Banner Flow Started", eventProperties, "fIlQMjt5lY", "43e88f200ec92d378bb53a6994d8f012021cb56df443ee826fd90535059b3e32");
    }
    // destination Www
    Www.logEvent("Banner Flow Started", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Banner Flow Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingBackButtonPressedProperties {
  origin: string | null | undefined;
}
/**
 * Onboarding Back Button Pressed: Triggered when the back button is pressed during the Onboarding Flow. Returns user to the previous onboarding step.
 *
 * When to trigger this event:
 * 1. Triggered when the back button is pressed during the onboarding flow. Returns to the previous step.
 * View in Avo: https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/P_CE_j-sg0/trigger/xXac6mDoh
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/P_CE_j-sg0}
 */
export function onboardingBackButtonPressed(
  properties: OnboardingBackButtonPressedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.origin !== undefined && properties.origin !== null ?
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin}) :
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "P_CE_j-sg0", "e7e1df01d2b2e5a5f73cb6ba5935ca9fad1d4261249f40059dff9107307c0c33", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding Back Button Pressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("P_CE_j-sg0", "Onboarding Back Button Pressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Back Button Pressed", eventProperties, "P_CE_j-sg0", "e7e1df01d2b2e5a5f73cb6ba5935ca9fad1d4261249f40059dff9107307c0c33");
    }
    // destination Www
    Www.logEvent("Onboarding Back Button Pressed", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Onboarding Back Button Pressed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Listening Goal Increased: Triggered when the user clicks the plus button to increase their listening goal on the Onboarding flow.
 *
 * When to trigger this event:
 * 1. Triggered every time the plus button is clicked.
 * View in Avo: https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/AsgQyQUJ-J/trigger/aOJvS1LMi
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/AsgQyQUJ-J}
 */
export function listeningGoalIncreased() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "AsgQyQUJ-J", "a14548327650ced096ce9a8214b66f7453bb5c03f9ffa01807744a1e471dbfc4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Listening Goal Increased", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("AsgQyQUJ-J", "Listening Goal Increased", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Listening Goal Increased", eventProperties, "AsgQyQUJ-J", "a14548327650ced096ce9a8214b66f7453bb5c03f9ffa01807744a1e471dbfc4");
    }
    // destination Www
    Www.logEvent("Listening Goal Increased", (Object as any).assign({}, eventProperties));

  } else {
    // do nothing
  }
}

/**
 * Listening Goal Decreased: Triggered when the user clicks the minus button to decrease their listening goal on the Onboarding flow.
 *
 * When to trigger this event:
 * 1. Triggered every time the minus button is clicked.
 * View in Avo: https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/CB1L39-Am/trigger/-_09hP-R0T
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/CB1L39-Am}
 */
export function listeningGoalDecreased() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "CB1L39-Am", "2d147e3a1e8f8277f6f32b8dbdb38ac807adc1452496dd2c14fe1c2f6a2c0f74", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Listening Goal Decreased", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("CB1L39-Am", "Listening Goal Decreased", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Listening Goal Decreased", eventProperties, "CB1L39-Am", "2d147e3a1e8f8277f6f32b8dbdb38ac807adc1452496dd2c14fe1c2f6a2c0f74");
    }
    // destination Www
    Www.logEvent("Listening Goal Decreased", (Object as any).assign({}, eventProperties));

  } else {
    // do nothing
  }
}

export interface SetAGoalProperties {
  origin: string;
  dailyListeningGoalMinutes: number;
}
/**
 * Set a Goal: When user sets a listening goal during the Onboarding Flow
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 * @param properties.dailyListeningGoalMinutes: Daily Listening Goal Minutes
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/foyhT8mmH}
 */
export function setAGoal(properties: SetAGoalProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "Rb8Hn6SNU", name: "daily_listening_goal_minutes", value: properties.dailyListeningGoalMinutes});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "foyhT8mmH", "c342c914d4ca964802df11844fbd190e67d30985b74bb510b536742b187ef0f7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Set a Goal", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("foyhT8mmH", "Set a Goal", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Set a Goal", eventProperties, "foyhT8mmH", "c342c914d4ca964802df11844fbd190e67d30985b74bb510b536742b187ef0f7");
    }
    // destination Www
    Www.logEvent("Set a Goal", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Set a Goal", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface Start3dsPaymentValidationProperties {
  paymentIntent: string;
  origin: string;
}
/**
 * Start 3ds Payment Validation: This will execute when the bank requires customers to complete an additional verification step when paying the subscription.
 *
 * @param properties the properties associatied with this event
 * @param properties.paymentIntent: The stripe payment intent id
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/DeKpehrVu2}
 */
export function start3dsPaymentValidation(
  properties: Start3dsPaymentValidationProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vWS_r15WT", name: "payment_intent", value: properties.paymentIntent});
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "DeKpehrVu2", "ee4dd0f955491d30ab555c5785476963e50f6d668e209bd4ab6440ea4718c69c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Start 3ds Payment Validation", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("DeKpehrVu2", "Start 3ds Payment Validation", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Start 3ds Payment Validation", eventProperties, "DeKpehrVu2", "ee4dd0f955491d30ab555c5785476963e50f6d668e209bd4ab6440ea4718c69c");
    }
    // destination Www
    Www.logEvent("Start 3ds Payment Validation", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Start 3ds Payment Validation", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface Succeeded3dsPaymentValidationProperties {
  paymentIntent: string;
  origin: string;
}
/**
 * Succeeded 3ds Payment Validation: This will be executed when the user has validated his payment method through stripe 3ds successfully.
 *
 * @param properties the properties associatied with this event
 * @param properties.paymentIntent: The stripe payment intent id
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/5XSUY9XCqR}
 */
export function succeeded3dsPaymentValidation(
  properties: Succeeded3dsPaymentValidationProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vWS_r15WT", name: "payment_intent", value: properties.paymentIntent});
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "5XSUY9XCqR", "c9757c0e004183ad65b97f66b7c25214ecff856a6e0ebfcefbb4eada0ba17235", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Succeeded 3ds Payment Validation", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("5XSUY9XCqR", "Succeeded 3ds Payment Validation", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Succeeded 3ds Payment Validation", eventProperties, "5XSUY9XCqR", "c9757c0e004183ad65b97f66b7c25214ecff856a6e0ebfcefbb4eada0ba17235");
    }
    // destination Www
    Www.logEvent("Succeeded 3ds Payment Validation", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Succeeded 3ds Payment Validation", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface Failed3dsPaymentValidationProperties {
  paymentIntent: string;
  errorMessage: string;
  origin: string;
}
/**
 * Failed 3ds Payment Validation: This will be executed when the user payment method validation through stripe 3ds has failed
 *
 * @param properties the properties associatied with this event
 * @param properties.paymentIntent: The stripe payment intent id
 * @param properties.errorMessage: This property send the error message that is shown to the user. Sometimes Twitter, Google, or Facebook sends this message, and sometimes this information is sent by Beek.
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/cMjc6DoQ-f}
 */
export function failed3dsPaymentValidation(
  properties: Failed3dsPaymentValidationProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vWS_r15WT", name: "payment_intent", value: properties.paymentIntent});
  eventPropertiesArray.push({id: "x2ihd067l", name: "error_message", value: properties.errorMessage});
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "cMjc6DoQ-f", "9be11f441d522b40bd36b35369019d651bd94c653b89b942d7baab157923e569", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Failed 3ds Payment Validation", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("cMjc6DoQ-f", "Failed 3ds Payment Validation", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Failed 3ds Payment Validation", eventProperties, "cMjc6DoQ-f", "9be11f441d522b40bd36b35369019d651bd94c653b89b942d7baab157923e569");
    }
    // destination Www
    Www.logEvent("Failed 3ds Payment Validation", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Failed 3ds Payment Validation", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LoginFlowStartedProperties {
  origin: string | null | undefined;
  userEmail: string | null | undefined;
}
/**
 * Login Flow Started: This event should not be sent to Segment. It would increase our segment costs

When the login screen appears
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/kZwaAQyqGs/trigger/ZzsS3N6tB
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 * @param properties.userEmail: The user email that will be sent
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/kZwaAQyqGs}
 */
export function loginFlowStarted(properties: LoginFlowStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.origin !== undefined && properties.origin !== null ?
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin}) :
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: null});
  properties.userEmail !== undefined && properties.userEmail !== null ?
    eventPropertiesArray.push({id: "0_W4C0h3m", name: "user_email", value: properties.userEmail}) :
    eventPropertiesArray.push({id: "0_W4C0h3m", name: "user_email", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "kZwaAQyqGs", "de93dc257907453b11474bd039c3e19d2f366ea3a6a94d27b8a167b3e36e9a09", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Login Flow Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("kZwaAQyqGs", "Login Flow Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Login Flow Started", eventProperties, "kZwaAQyqGs", "de93dc257907453b11474bd039c3e19d2f366ea3a6a94d27b8a167b3e36e9a09");
    }
    // destination GoogleTagManager
    GoogleTagManager.logEvent("Login Flow Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Welcome Flow Started: This event should not be sent to Segment. It would increase our segment costs

When the user lands on the welcome-flow screen
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/rqrNOi0R65/trigger/v7IN_63cH
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/rqrNOi0R65}
 */
export function welcomeFlowStarted() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "rqrNOi0R65", "50c668fdd925f60e91a230b29c6f2fe9c19f679a9bc707f621fb43e29448a563", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Welcome Flow Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("rqrNOi0R65", "Welcome Flow Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Welcome Flow Started", eventProperties, "rqrNOi0R65", "50c668fdd925f60e91a230b29c6f2fe9c19f679a9bc707f621fb43e29448a563");
    }
    // destination GoogleTagManager
    GoogleTagManager.logEvent("Welcome Flow Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DownloadAppButtonPressedProperties {
  origin: string | null | undefined;
}
/**
 * Download App Button Pressed: When the user pressed the download button
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/asXbHHnD5D/trigger/8mDuSS_IL
 * 2.
 * View in Avo: https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/asXbHHnD5D/trigger/AJr06hmgr
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/asXbHHnD5D}
 */
export function downloadAppButtonPressed(
  properties: DownloadAppButtonPressedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.origin !== undefined && properties.origin !== null ?
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin}) :
    eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: null});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "asXbHHnD5D", "3b0a65fc9f6946be27884ca65d0da2f913141b13c07a786e1070cb55b1be2089", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Download App Button Pressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("asXbHHnD5D", "Download App Button Pressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Download App Button Pressed", eventProperties, "asXbHHnD5D", "3b0a65fc9f6946be27884ca65d0da2f913141b13c07a786e1070cb55b1be2089");
    }
    // destination Www
    Www.logEvent("Download App Button Pressed", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Download App Button Pressed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface WebPlayerSettingsButtonClickedProperties {
  origin: string;
}
/**
 * Web Player Settings Button Clicked: Used to track clicks on www settings menu for Web Player link item
 *
 * When to trigger this event:
 * 1. Button for "Web Player" clicked
 * View in Avo: https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/w0a7FTqBSQ/trigger/Bjp7uWqPL
 *
 * @param properties the properties associatied with this event
 * @param properties.origin: This property sends the information of the specific location from where an event is sent.
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/w0a7FTqBSQ}
 */
export function webPlayerSettingsButtonClicked(
  properties: WebPlayerSettingsButtonClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "d_ylRWw8y", name: "origin", value: properties.origin});
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "w0a7FTqBSQ", "02a1a076690097d2fe17d2d4ffcdbcc10453376250186a67ca6ea4974a646d94", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Web Player Settings Button Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("w0a7FTqBSQ", "Web Player Settings Button Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Web Player Settings Button Clicked", eventProperties, "w0a7FTqBSQ", "02a1a076690097d2fe17d2d4ffcdbcc10453376250186a67ca6ea4974a646d94");
    }
    // destination Www
    Www.logEvent("Web Player Settings Button Clicked", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Web Player Settings Button Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Checkout Page Opened: when the second checkout screen is displayed
 *
 * @see {@link https://www.avo.app/schemas/WT5UNEkzLbpQZNA6yhMA/events/Ta5C15ZrAB}
 */
export function checkoutPageOpened() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "julD8m3n-", name: "context_device_type", value: sysContextDeviceType});
  eventPropertiesArray.push({id: "KRCNDQIor", name: "context_library_name", value: sysContextLibraryName});
  eventPropertiesArray.push({id: "lcwGpdBEM", name: "context_library_version", value: sysContextLibraryVersion});
  eventPropertiesArray.push({id: "1HRyz8RVb", name: "source", value: sysSource});
  eventPropertiesArray.push({id: "ayJnKZvqhE", name: "acquisition_channel", value: sysAcquisitionChannel});
  eventPropertiesArray.push({id: "idNNw87D7Z", name: "marketing_title", value: sysMarketingTitle});
  eventPropertiesArray.push({id: "on-p_A0Z26", name: "context_utm_campaign", value: sysContextUtmCampaign});
  eventPropertiesArray.push({id: "14IzLq_MKd", name: "context_utm_medium", value: sysContextUtmMedium});
  eventPropertiesArray.push({id: "h5xei-H_ZY", name: "tags", value: sysTags});
  eventPropertiesArray.push({id: "J2hf572i89", name: "campaign", value: sysCampaign});
  eventPropertiesArray.push({id: "tQtxq3U7R-", name: "media_source", value: sysMediaSource});
  eventPropertiesArray.push({id: "l0WGPeNykw", name: "channel", value: sysChannel});
  eventPropertiesArray.push({id: "4oD8fQec10", name: "context_utm_source", value: sysContextUtmSource});
  eventPropertiesArray.push({id: "b_dZPhVAD-", name: "context_utm_content", value: sysContextUtmContent});
  eventPropertiesArray.push({id: "wfTBNMqciY", name: "offer", value: sysOffer});
  eventPropertiesArray.push({id: "drFFTTXyO1", name: "context_utm_term", value: sysContextUtmTerm});
  eventPropertiesArray.push({id: "z7e69cfKMe", name: "connection_type", value: sysConnectionType});
  eventPropertiesArray.push({id: "oomZPISTRY", name: "is_online", value: sysIsOnline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Ta5C15ZrAB", "000e5335b27b8847029555c4137f6613f75d89308e3cb8d0a2a602562a36cc31", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Checkout Page Opened", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Ta5C15ZrAB", "Checkout Page Opened", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checkout Page Opened", eventProperties, "Ta5C15ZrAB", "000e5335b27b8847029555c4137f6613f75d89308e3cb8d0a2a602562a36cc31");
    }
    // destination Www
    Www.logEvent("Checkout Page Opened", (Object as any).assign({}, eventProperties));

    // destination GoogleTagManager
    GoogleTagManager.logEvent("Checkout Page Opened", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  Source,
  ContextLibraryName,
  FieldName,
  PlanType,
  ContextDeviceType,
  Provider,
  userLoggedIn,
  userCreated,
  logOutButtonPressed,
  logOutConfirmed,
  experimentRendered,
  subscriptionStartErrorTriggered,
  subscriptionSignUpScreenClosed,
  addPaymentMethodButtonPressed,
  addPaymentMethodConfirmed,
  addPaymentMethodError,
  subscriptionFlowStarted,
  subscriptionPurchased,
  freeTrialStarted,
  subscriptionPaymentFieldFocused,
  subscriptionPurchaseErrorTriggered,
  audiobookSavedConfirmed,
  onboardingFlowStarted,
  categoryPicked,
  onboardingContinueButtonPressed,
  onboardingSkipButtonPressed,
  onboardingFlowFinished,
  audiobookSamplePlayButtonPressed,
  audiobookSamplePauseButtonPressed,
  subscriptionPlanPicked,
  keepSubscriptionButtonPressed,
  cancellationReasonPicked,
  startButtonPressed,
  signupFlowStarted,
  startSubscriptionTrialButtonClicked,
  onboardingFlowAborted,
  webPlayerButtonPressed,
  bannerFlowStarted,
  onboardingBackButtonPressed,
  listeningGoalIncreased,
  listeningGoalDecreased,
  setAGoal,
  start3dsPaymentValidation,
  succeeded3dsPaymentValidation,
  failed3dsPaymentValidation,
  loginFlowStarted,
  welcomeFlowStarted,
  downloadAppButtonPressed,
  webPlayerSettingsButtonClicked,
  checkoutPageOpened,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["userLoggedIn","userCreated","logOutButtonPressed","logOutConfirmed","experimentRendered","subscriptionStartErrorTriggered","subscriptionSignUpScreenClosed","addPaymentMethodButtonPressed","addPaymentMethodConfirmed","addPaymentMethodError","subscriptionFlowStarted","subscriptionPurchased","freeTrialStarted","subscriptionPaymentFieldFocused","subscriptionPurchaseErrorTriggered","audiobookSavedConfirmed","onboardingFlowStarted","categoryPicked","onboardingContinueButtonPressed","onboardingSkipButtonPressed","onboardingFlowFinished","audiobookSamplePlayButtonPressed","audiobookSamplePauseButtonPressed","subscriptionPlanPicked","keepSubscriptionButtonPressed","cancellationReasonPicked","startButtonPressed","signupFlowStarted","startSubscriptionTrialButtonClicked","onboardingFlowAborted","webPlayerButtonPressed","bannerFlowStarted","onboardingBackButtonPressed","listeningGoalIncreased","listeningGoalDecreased","setAGoal","start3dsPaymentValidation","succeeded3dsPaymentValidation","failed3dsPaymentValidation","loginFlowStarted","welcomeFlowStarted","downloadAppButtonPressed","webPlayerSettingsButtonClicked","checkoutPageOpened"]
